import { useCallback } from 'react';
import { getShortContentUrl, useShortFromPropsOrParams } from '..';
import { ContentLanguageSelector } from '../../contentLanguage';
import { LearningContentPageHeader } from '../../learningContent';
import useNavigate from '../../../hooks/useNavigate';
import { SocialShareDropdown } from '../../share';
import styled, { theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
import { ListVerticalRule } from '../../lists';
import { CardMenuIcon, MenuButton } from '../../cardMenu';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { CaretForward } from '../../../components/Modals/FullScreenModal/MobileNestedMenu';
import MobileFilterSingleSelect from '../../../containers/TracksPage/MobileFilterSingleSelect';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CardMenuIconContainer = styled.div.withConfig({
  displayName: "ShortContentHeader__CardMenuIconContainer",
  componentId: "sc-1f3dkn1-0"
})([".card-menu-icon{background-color:transparent;border:2px solid ", ";}"], theme.colors.EERIE);
export const ShortContentHeader = props => {
  const {
    short,
    playlistId
  } = useShortFromPropsOrParams(props);
  const navigate = useNavigate();
  const {
    isMobile
  } = useMediaQuery();
  const handleOnLanguageChange = useCallback(newLanguage => {
    if (!short) return;
    const {
      language,
      contentId: shortId
    } = short;
    UsageTracker.track('interaction', {
      action: `short-content-language-change`,
      shortId,
      language
    });
    if (language.toUpperCase() !== newLanguage.toUpperCase()) navigate(getShortContentUrl({
      shortId,
      language: newLanguage.toLowerCase(),
      playlistId
    }));
  }, [navigate, playlistId, short]);
  if (!short) return null;
  const {
    name,
    language,
    languages,
    contentId: shortId
  } = short;
  return /*#__PURE__*/_jsx(LearningContentPageHeader, {
    item: {
      id: shortId,
      type: 'SHORT_FORM_CONTENT',
      language,
      playlistId
    },
    title: name,
    children: isMobile ? /*#__PURE__*/_jsx(CardMenuIconContainer, {
      style: {
        marginRight: 4
      },
      children: /*#__PURE__*/_jsx(CardMenuIcon, {
        language: language,
        placement: "bottom left",
        renderExtraOptions: setIsOpen =>
        /*#__PURE__*/
        // @ts-expect-error Untyped
        _jsx("div", {
          nestedOptions: true,
          children: /*#__PURE__*/_jsxs(MenuButton, {
            "data-test-id": "mobile-change-language-button"
            // @ts-expect-error Untyped
            ,
            subpage: /*#__PURE__*/_jsx(MobileFilterSingleSelect, {
              allowList: languages,
              buttonStyle: {
                padding: '12px 20px'
              },
              bypassSearchParamUpdate: true,
              defaultItem: language,
              filterType: FILTER_TYPES.LANGUAGE,
              onSelect: newLanguage => {
                handleOnLanguageChange(newLanguage);
                setIsOpen(false);
              }
            }),
            use: "unstyled",
            children: [/*#__PURE__*/_jsxs("span", {
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.topFilters.language.filterTitle"
              }), ":\xA0", LanguageNames[language.toLowerCase()]]
            }), /*#__PURE__*/_jsx("span", {
              children: /*#__PURE__*/_jsx(CaretForward, {
                color: theme.colors.EERIE
              })
            })]
          })
        }),
        shortId: shortId
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ContentLanguageSelector, {
        availableLanguages: languages,
        language: language,
        onLanguageChange: handleOnLanguageChange
      }), /*#__PURE__*/_jsx(ListVerticalRule, {}), /*#__PURE__*/_jsx(CardMenuIconContainer, {
        className: "m-right-3",
        children: /*#__PURE__*/_jsx(CardMenuIcon, {
          language: language,
          placement: "bottom left",
          shortId: shortId
        })
      }), /*#__PURE__*/_jsx(SocialShareDropdown, {
        language: language,
        shortId: shortId
      })]
    })
  });
};
export default ShortContentHeader;